<h2 mat-dialog-title>Delete Current Individual?</h2>
<mat-dialog-content class="mat-dialog-content"> {{ individual.full_name }} </mat-dialog-content>
<mat-dialog-actions class="mat-dialog-actions">
    <button [mat-dialog-close]="true" mat-button>Yes</button>
    <button [mat-dialog-close]="false" mat-button>No</button>
</mat-dialog-actions>
